import { Store } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/** Shown when a list is empty while a specific store is selected, so nobody thinks the
 *  records have been lost. The owner panicked over exactly this once. */
export const EmptyBranchNote = ({ className = "" }) => {
  const { branch } = useAuth();
  if (!branch) return null;
  return (
    <div
      className={`flex items-start gap-3 border border-[#E0D7C4] bg-[#FBF8F2] px-4 py-3 text-left ${className}`}
      data-testid="empty-branch-note"
    >
      <Store className="mt-0.5 h-4 w-4 shrink-0 text-[#B38F4E]" />
      <p className="text-sm text-[#6B5A3E]">
        Nothing here for <strong>{branch}</strong> — this store has no records to show.
        Nothing has been deleted. Use the <strong>branch selector at the top</strong> of
        the screen to look at the other store.
      </p>
    </div>
  );
};
